import {useEffect, useRef, useState} from "react";
import ReactDOM from "react-dom";

export const useScroll = () => {
    const [scroll, setScroll] = useState(null);
    const [scrollDirection, setScrollDirection] = useState(null);

    useEffect(() => {
        const handleScroll = (event) => {
            let currentScroll = getCurrentScroll();

            // TODO: Setting scroll direction might not work
            // double check when doing mobile styling
            if (currentScroll < 115) {
                setScrollDirection(null);
            }
            else if (currentScroll > scroll) {
                setScrollDirection('down');
            } else {
                setScrollDirection('up');
            }

            if(currentScroll !== scroll) {
                setScroll(currentScroll);
            }
        };

        setScroll(getCurrentScroll());
        window.addEventListener('scroll', handleScroll);


        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    return {scroll, scrollDirection};
};


const getCurrentScroll = () => {
    return document.documentElement.scrollTop;
};

export const useScrollToRef = (initialRef = null) => {
    const elementRef = useRef(initialRef);
    return [
        elementRef,
        () => {
            ReactDOM.findDOMNode(elementRef?.current)?.scrollIntoView({behavior: 'smooth'});
        }
    ];
}
